<template>
  <div class="loading-spinner" :class="containerClass">
    <div class="spinner" :class="spinnerSizeClass">
      <div class="spinner__circle"></div>
    </div>
    <p v-if="text" class="loading-spinner__text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    // 로딩 텍스트
    text: {
      type: String,
      default: '로딩 중...'
    },
    // 크기: small, medium, large
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    // 컨테이너 스타일 (fullscreen, inline, overlay)
    container: {
      type: String,
      default: 'inline',
      validator: (value) => ['fullscreen', 'inline', 'overlay'].includes(value)
    }
  },
  computed: {
    spinnerSizeClass() {
      return `spinner--${this.size}`;
    },
    containerClass() {
      return `loading-spinner--${this.container}`;
    }
  }
};
</script>

<style scoped lang="scss">
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  &--inline {
    padding: 40px 20px;
  }

  &--fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    z-index: 9999;
  }

  &--overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    z-index: 100;
  }
}

.spinner {
  position: relative;
  display: inline-block;

  &--small {
    width: 24px;
    height: 24px;
  }

  &--medium {
    width: 40px;
    height: 40px;
  }

  &--large {
    width: 60px;
    height: 60px;
  }

  &__circle {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #222;
    animation: spin 0.8s linear infinite;
  }
}

.loading-spinner__text {
  margin: 0;
  font-size: 16px;
  color: #666;
  font-weight: 500;
  letter-spacing: -0.3px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
